import React from 'react';

const SignInWithMicrosoft: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="160"
    height="37"
    viewBox="0 0 175 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    {/* Black rounded rectangle background matching Google button */}
    <rect x="0.5" y="0.5" width="174" height="39" rx="19.5" fill="#131314" />

    {/* Microsoft logo */}
    <g transform="translate(12, 12)">
      <rect x="0" y="0" width="7" height="7" fill="#F25022" />
      <rect x="9" y="0" width="7" height="7" fill="#7FBA00" />
      <rect x="0" y="9" width="7" height="7" fill="#00A4EF" />
      <rect x="9" y="9" width="7" height="7" fill="#FFB900" />
    </g>

    {/* "Sign in with Microsoft" text in white/gray matching Google button */}
    <text
      x="35"
      y="20"
      fontFamily="Segoe UI, Arial, sans-serif"
      fontSize="12.5"
      fontWeight="bold"
      fill="#E3E3E3"
      dominantBaseline="middle"
    >
      Sign in with Microsoft
    </text>

    {/* Border matching Google button */}
    <rect x="0.5" y="0.5" width="174" height="39" rx="19.5" stroke="#8E918F" />
  </svg>
);

export default SignInWithMicrosoft;
